<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 col-md-6">
      <GlassCard class="q-pa-xs">
        <CampusPlusLogo size="64" style="float: right; margin-right: -10px; margin-left: 10px; margin-top: -10px" />
        <h1 class="q-mb-md">{{ $t("portal.start.welcome.heading") }}</h1>
        <p class="q-mb-sm">
          {{ $t("portal.start.welcome.body") }}
        </p>

        <div class="q-mt-lg q-mb-none">
          <h5>{{ $t("portal.start.labels.newsletter") }}:</h5>
          <i18n-t keypath="portal.start.newsletter.body" tag="p" scope="global"><a
              href="https://www.lists.kit.edu/sympa/subscribe/campusplus">{{ $t("portal.start.newsletter.name")
              }}</a></i18n-t>
        </div>


        <q-btn :icon="symOutlinedImportContacts" size="md" no-caps color="blue" class="q-mb-md"
          :to="{ name: 'SMUProceduresList' }">&nbsp;{{ $t('portal.gotosignmeup') }}</q-btn>

        <p v-if="!isLoggedIn">
          {{ $t("portal.start.login.requiredText") }}<br />
          <q-btn color="teal" href="/api/user/oidc-login" class="q-mt-sm q-mr-sm" :icon="symOutlinedLogin"
            :label="t('portal.start.login.loginKIT')"></q-btn>
          <q-btn color="purple" :to="{ name: 'Login' }" class="q-mt-sm q-mr-sm" :icon="symOutlinedLogin"
            :label="t('portal.start.login.loginExternal')"></q-btn>
          <q-btn color="indigo" :to="{ name: 'Register' }" class="q-mt-sm" :icon="symOutlinedAppRegistration"
            :label="t('portal.start.login.register')"></q-btn>
        </p>
      </GlassCard>
    </div>
    <div class="col-12 col-md-6">
      <GlassCard class="q-pa-xs">
        <h2 class="q-mb-sm">{{ $t("common.labels.changes") }}</h2>


        <h5>Version 2.7.6: SignMeUp: Zusätzlicher Abschluss als Restriktion, Ausblenden von beendeten Verfahren,
          Verbesserungen beim Login
        </h5>
        <div class="text-caption text-bold">08.11.2023 <sup class="text-red">neu</sup></div>
        <p>
          Ab sofort kann in den Verfahren der Abschluss "Zeitstudium" zugelassen werden. Es handelt sich hierbei um
          Studiengänge mit den Präfixen 96 und 97, welche z.B. für Erasmus-Studierende verwendet werden. In der
          Verwalten-Ansicht können beendete Verfahren jetzt bequem über eine Checkbox ausgeblendet werden. Beim Aufruf von
          Seiten, welche eine Anmeldung erfordern (z.B. auch private Anmeldelinks) werden Nutzer nun nach dem Login wieder
          korrekt auf die vorherige Seite zurückgeleitet statt auf die Startseite.
        </p>

        <h5>Version 2.7.5: SignMeUp: Studierende als Tutoren, Anzeige von Lerngruppenmitgliedern
        </h5>
        <div class="text-caption text-bold">02.11.2023 </div>
        <p>
          In Themen und Terminen lassen sich nun auch Studierende als zugehörige Person eintragen und als Tutor nach ILIAS
          exportieren.<br />
          In der Teilnehmerliste können Sie unter Darstellung nun die Anzeige aller Lerngruppenmitglieder einschalten. Sie
          sehen diese dann direkt in der Teilnehmerliste.
        </p>


        <h5>Version 2.7.4: SignMeUp: Teilnehmer filtern, fester Tabellenkopf in der Teilnehmerliste, Massenexport mit
          Teilnehmerzahlen
        </h5>
        <div class="text-caption text-bold">30.10.2023</div>
        <p>
          In diesem Release bringen wir Ihnen einige Verbesserungen aufgrund Nutzerfeedbacks:<br />
          Die Teilnehmerliste kann nun nach Personen gefiltert werden. Dabei werden auch Lerngruppenmitglieder
          berücksichtigt. Die Filterung ist nach Name, Matrikelnummer und Account möglich.
          Zusätzlich lässt sich im Darstellungsmodus ein angehefteter Tabellenkopf einschalten, so dass Sie die Themen und
          Belegung auch beim Scrollen im Blick behalten. Auf breiten Monitoren nutzt die Teilnehmerliste nun auch in der
          Breite den ganzen verfügbaren Platz.
          Der Massenexport über mehrere Veranstaltungen liefert Ihnen nun auch eine Angabe über die Anzahl Anmeldungen und
          Zusagen zur Archivierung oder Verarbeitung.
        </p>




        <p class="q-mt-sm">
          {{ $t("portal.start.changes.allchangestext") }}
          <a href=" https://docs.campus.kit.edu/updates/" target="_blank" class="text-blue text-bold">{{
            $t("portal.start.changes.versinfo")
          }}</a>.
        </p>
      </GlassCard>
    </div>
    <!-- <div>
        <q-btn class=" q-ma-xs" color="primary">Primary</q-btn>
              <q-btn class="q-ma-xs" color="secondary">secondary</q-btn>
              <q-btn class="q-ma-xs" color="accent">accent</q-btn>
              <q-btn class="q-ma-xs" color="positive">positive</q-btn>
              <q-btn class="q-ma-xs" color="negative">negative</q-btn>
              <q-btn class="q-ma-xs" color="info">info</q-btn>
              <q-btn class="q-ma-xs" color="warning">warning</q-btn>
              <q-btn class="q-ma-xs" color="main">main</q-btn>
              <q-btn class="q-ma-xs" color="content">content</q-btn>
              <q-btn class="q-ma-xs" color="content-2">content-2</q-btn><br />
              <q-btn class="q-ma-xs" color="pantone-illuminating">pantone-illuminating</q-btn>
              <q-btn class="q-ma-xs" color="pantone-illuminating-complementary">pantone-illuminating-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-classic-blue">pantone-classic-blue</q-btn>
              <q-btn class="q-ma-xs" color="pantone-classic-blue-complementary">pantone-classic-blue-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-kingfisher-blue">pantone-kingfisher-blue</q-btn>
              <q-btn class="q-ma-xs" color="pantone-kingfisher-blue-complementary">pantone-kingfisher-blue-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-very-peri">pantone-very-peri</q-btn>
              <q-btn class="q-ma-xs" color="campus-yellow">campus-yellow</q-btn>
      </div> -->
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import CampusPlusLogo from "@/components/shared/CampusPlusLogo.vue";
import useUserProfile from "@/composables/useUserProfile";
import { symOutlinedAppRegistration, symOutlinedImportContacts, symOutlinedList, symOutlinedLogin } from "@quasar/extras/material-symbols-outlined";
import { useTitle } from "@vueuse/core";

import GlassCard from "../components/shared/GlassCard.vue";
import MiniCard from "../components/shared/MiniCard.vue";

const { t } = useI18n();
const { isLoggedIn } = useUserProfile();

useTitle(computed(() => "Campus Plus Portal - " + t("portal.start.welcome.label")));
</script>
